import React, { Suspense, useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

// ** Router Import
import Router from './router/Router'

// ** Routes & Default Routes
import { getRoutes } from './router/routes'

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout'
import toast from 'react-hot-toast'
import Spinner from './@core/components/spinner/Fallback-spinner'
import {
  AuthContext,
  JunctionContext,
  SingleJunctionContext,
  UserContext,
} from './context'

const App = () => {
  const [allRoutes, setAllRoutes] = useState([])
  const [junctionId, setJunctionId] = useState()
  const [junctionName, setJunctionName] = useState()
  const [junction, setJunction] = useState()
  const [token, setToken] = useState(null)
  const [user, setUser] = useState(null)

  const getJunctionId = () => {
    const retrieveId = window.localStorage.getItem(
      process.env.REACT_APP_XITS_JUNCTION_ID
    )

    const retrieveName = window.localStorage.getItem(
      process.env.REACT_APP_XITS_JUNCTION_NAME
    )

    const retrieveJunction = window.localStorage.getItem(
      process.env.REACT_APP_XITS_JUNCTION
    )

    if (retrieveId && retrieveId !== 'undefined') {
      setJunctionId(retrieveId)
      setJunctionName(retrieveName)
      setJunction(JSON.parse(retrieveJunction))
    }
  }

  useEffect(() => {
    getJunctionId()
  }, [junctionId])

  const setUserInformation = () => {
    const retrieveToken = window.localStorage.getItem(
      process.env.REACT_APP_XITS_TOKEN_KEY
    )
    const userData = window.localStorage.getItem(
      process.env.REACT_APP_XITS_USER_KEY
    )

    if (retrieveToken === 'undefined') {
      window.localStorage.removeItem(process.env.REACT_APP_XITS_TOKEN_KEY)
      window.localStorage.removeItem(process.env.REACT_APP_XITS_USER_KEY)
      toast.error("Your session expired. You've to login again")
      return
    }

    if (retrieveToken && retrieveToken !== 'undefined') {
      setToken(retrieveToken)
      setUser(JSON.parse(userData))
    }
  }

  useEffect(() => {
    setUserInformation()
  }, [])

  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (
        e.key === process.env.REACT_APP_XITS_TOKEN_KEY &&
        e.oldValue !== e.newValue
      ) {
        setUserInformation()
        window.location.reload()
        history.push(NavRoutes.home)
      }
    }
    window.addEventListener('storage', handleInvalidToken, false)
    return function cleanup() {
      window.removeEventListener('storage', handleInvalidToken)
    }
  }, [token])

  // ** Hooks
  const { layout } = useLayout()

  const queryClient = new QueryClient()

  useEffect(() => {
    setAllRoutes(getRoutes(layout))
  }, [layout])

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Spinner />}>
        <JunctionContext.Provider
          value={{ junctionId, setJunctionId, junctionName, setJunctionName }}
        >
          <SingleJunctionContext.Provider value={{ junction, setJunction }}>
            <UserContext.Provider value={{ user, setUser }}>
              <AuthContext.Provider value={{ token, setToken }}>
                <Router allRoutes={allRoutes} />
              </AuthContext.Provider>
            </UserContext.Provider>
          </SingleJunctionContext.Provider>
        </JunctionContext.Provider>
      </Suspense>
    </QueryClientProvider>
  )
}

export default App
